import type { FabricEditor } from 'modules/fabric-editor';
import { selectActiveTemplate } from 'modules/manager/store';
import { useEffect, useRef } from 'react';
import { useAppSelector } from 'store/hooks';

export function useRestoreTemplate(editor: FabricEditor | null): void {
  const template = useAppSelector(selectActiveTemplate);
  const restoredFor = useRef<number | null>(null);

  useEffect(() => {
    if (!editor || !template) return;
    if (restoredFor.current === template.id) return;
    restoredFor.current = template.id;

    const payload = { version: template.version, objects: template.objects ?? [] };
    editor.canvas.loadFromJSON(payload, () => {
      editor.canvas.renderAll();
      editor.emit('canvas:loaded', { source: 'restore' });
      editor.history?.clear();
      editor.dirty?.markClean();
    });
  }, [editor, template]);
}
